<template>
  <div class="yiwanchenggongdan">
    <el-scrollbar id="menuWarpper"
                  style="height:calc(100%);">
      <el-main>
        <div class="header"
             ref="header">
          <div class="headerTop">
            <div class="header-con">
              <el-form class="header-con-form"
                       :inline="true">
                <el-form-item class="header-con-form-item"
                              label="工单编号:">
                  <el-input v-model="gongdanCode"
                            class="form-item-inputcpx"
                            placeholder="请输入"
                            @keyup.enter.native="ChaXun(1)"
                            clearable>
                  </el-input>
                </el-form-item>
                <el-form-item class="header-con-form-item"
                              label="产品线:">
                  <el-select v-model="chanpinxian"
                             placeholder="请选择"
                             clearable
                             multiple
                             size="small"
                             class="form-item-inputcpx"
                             @change="dianjichanpinxian"
                             popper-class="eloption">
                    <el-option v-for="item in staff"
                               :key="item.Code"
                               :label="item.Name"
                               :value="item.Code" />
                  </el-select>
                  <!-- 	<el-select class="form-item-inputcpx" v-model="chanpinxian" filterable clearable
											placeholder="输入关键词搜索" :filter-method="bindSelectChange"
											@change="dianjichanpinxian" popper-class="eloption"
											:popper-append-to-body="false">
											<el-option v-for="item in staff" :key="item.Code" :label="item.Name"
												:value="item.Code">
											</el-option>
										</el-select> -->
                  <!-- <el-input v-model="templateName" style="width: 200px" placeholder="请输入"></el-input> -->
                </el-form-item>
                <el-form-item class="header-con-form-item"
                              label="起始日期:">
                  <el-date-picker class="form-item-inputcpx"
                                  :clearable="false"
                                  v-model="kaishishijian"
                                  type="date"
                                  range-separator="至"
                                  value-format="yyyy-MM-dd"
                                  start-placeholder="开始日期"
                                  end-placeholder="结束日期">
                  </el-date-picker>
                </el-form-item>
                <el-form-item class="header-con-form-item"
                              label="终止日期:">
                  <el-date-picker class="form-item-inputcpx"
                                  :clearable="false"
                                  v-model="jieshushijian"
                                  type="date"
                                  range-separator="至"
                                  value-format="yyyy-MM-dd"
                                  start-placeholder="开始日期"
                                  end-placeholder="结束日期">
                  </el-date-picker>
                </el-form-item>
                <el-button type="success"
                           class="anniuclass"
                           @click="ChaXun(1)"
                           :disabled="isChaXun">查询</el-button>
                <el-button type="primary"
                           class="anniuclass"
                           @click="xinjianGongDan()">新建工单</el-button>
              </el-form>

            </div>

          </div>
        </div>

        <div class="maina"
             v-bind:style="{height:EchartsHeight}">

          <el-table :data="tableData"
                    height="100%"
                    highlight-current-row
                    resizable
                    stripe
                    border
                    @row-dblclick="shuangjiChaKan">
            <el-table-column align="center"
                             type="index"
                             label="序号"
                             width="50">
            </el-table-column>
            <el-table-column align="center"
                             prop="CODE"
                             label="工单号"
                             width="150">
            </el-table-column>

            <el-table-column align="center"
                             prop="CUSTOMER_NAME"
                             label="客户名称"
                             min-width="180">
            </el-table-column>
            <el-table-column align="center"
                             prop="PRODUCT_LINE1"
                             label="产品线">
            </el-table-column>
            <el-table-column align="center"
                             prop="INFO_TYPE1"
                             label="类型">
            </el-table-column>
            <!-- <el-table-column align="center" prop="SPONSOR_NAME" label="发起人">
						</el-table-column> -->
            <el-table-column align="center"
                             prop="CONTACTS"
                             label="客户联系人"
                             width="150">
            </el-table-column>
            <el-table-column align="center"
                             prop="CONTACT_INFORMATION"
                             label="客户联系方式"
                             width="150">
            </el-table-column>
            <el-table-column align="center"
                             prop="JOB_NUMBER"
                             label="客服工号">
            </el-table-column>
            <el-table-column align="center"
                             prop="CUSTOMER_SERVICE_NAME"
                             label="接单人">
            </el-table-column>
            <el-table-column align="center"
                             prop="INFO_STATUS1"
                             label="状态">
            </el-table-column>
            <el-table-column align="center"
                             prop="LAUNCH_TIME"
                             label="发起日期"
                             width="150">
              <template v-if="scope.row.LAUNCH_TIME!=null"
                        slot-scope="scope">
                {{scope.row.LAUNCH_TIME.toLocaleString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')}}

              </template>
            </el-table-column>
            <el-table-column align="center"
                             prop="RECIVE_TIME"
                             label="接单日期"
                             width="150">
              <template v-if="scope.row.RECIVE_TIME!=null"
                        slot-scope="scope">
                {{scope.row.RECIVE_TIME.toLocaleString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')}}

              </template>
            </el-table-column>
            <el-table-column align="center"
                             prop="HANDLE_TIME"
                             label="处理时间"
                             width="150">
              <template v-if="scope.row.HANDLE_TIME!=null"
                        slot-scope="scope">
                {{scope.row.HANDLE_TIME.toLocaleString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')}}

              </template>
            </el-table-column>

            <el-table-column align="center"
                             prop="TERMINATE_TIME"
                             label="终止时间"
                             width="150">
              <template v-if="scope.row.TERMINATE_TIME!=null"
                        slot-scope="scope">
                {{scope.row.TERMINATE_TIME.toLocaleString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')}}

              </template>
            </el-table-column>
            <el-table-column align="center"
                             prop="Spend_TimeStr"
                             label="处理时长"
                             width="150"
                             show-overflow-tooltip>
            </el-table-column>
            <!-- <el-table-column align="center" prop="SPEND_TIME" label="处理时长/小时" width="150">
							<template v-if="scope.row.SPEND_TIME!=null" slot-scope="scope">
								{{scope.row.SPEND_TIME.toLocaleString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')}}

							</template>
						</el-table-column> -->
            <!-- <el-table-column align="center" prop="pingjiazhangtai" label="评价状态">
						</el-table-column>
						
						<el-table-column align="center" prop="SERVICE_EVALUATE" label="评价内容" width="240px">
						</el-table-column> -->

            <el-table-column align="center"
                             prop="pingjiazhangtai"
                             label="评价星级"
                             width="250px">

              <template slot-scope="scope">

                <p v-if="scope.row.pingjiazhangtai=='已评价'">
                  已评价
                  <el-rate ref="lb"
                           class="liebiao"
                           v-model="scope.row.SERVICE_STAR"
                           :colors="colors"
                           disabled>
                  </el-rate>

                </p>
                <p v-if="scope.row.pingjiazhangtai=='待评价'">
                  <el-button href="javascript:void(0)"
                             @click="pingjia(scope.$index)">待评价
                  </el-button>
                </p>
                <!-- <p v-if="scope.row.pingjiazhangtai=='评价已超时'">
									评价已超时
									<el-button href="javascript:void(0)" @click="pingjia(scope.$index)">评价已超时
									</el-button>
								</p> -->
                <!-- <p v-else>
									评价已超时
								
								
								</p> -->

              </template>
            </el-table-column>
            <!-- <el-table-column label="时间差" align="center" :formatter="formatGap" prop="HANDLE_TIME">

						</el-table-column> -->
            <el-table-column align="center"
                             prop="DESCRIBE"
                             label="留言"
                             width="240px">
            </el-table-column>
            <el-table-column align="center"
                             fixed="right"
                             label="操作"
                             width="100px">
              <template slot-scope="scope">
                <el-button type="primary"
                           @click="viewDoc(scope)">查看</el-button>
                <!-- <el-button type="success" @click="pingjia(scope.$index)">评价</el-button> -->
              </template>
            </el-table-column>

          </el-table>
        </div>
        <div class="footer"
             ref="footer">
          <pagination :allPage="allPage"
                      :pageSize="pageSize"
                      :currIndex="currPage"
                      @hanSiChange="hanSiChange"
                      @hanCurrChange="hanCurrChange"></pagination>
        </div>
      </el-main>
    </el-scrollbar>
    <!-- 评价 -->
    <el-dialog title="评价"
               :visible.sync="formDialog"
               width="800px">
      <div class="dialog-con">
        <el-col :span="24">
          <el-form class="header-con-form"
                   :inline="true">
            <div class="headerpingjia">
              感谢您真挚的评价，我们会继续努力的！
            </div>
          </el-form>
          <div class="taiyangImage">
            <img src="../../assets/img/xiaolian.png"
                 class="taiyangImagez">
          </div>
          <div class="headerfueuxingji">
            <el-form class="header-con-form"
                     :inline="true">

              <div class="fuwuxingjiwz">
                服务星级：
              </div>
              <el-rate v-model="xingji"
                       :colors="colors"
                       show-score
                       text-color="#ffffff"
                       score-template="{value}">
              </el-rate>

            </el-form>
          </div>
          <div class="headermiaoshu">
            <el-form class="header-con-form"
                     :inline="true">

              <div class="fuwuxingjiwza">
                留言板：
              </div>
              <el-input class="form-item-input"
                        type="textarea"
                        :rows="8"
                        placeholder="请输入内容"
                        v-model="miaoshu">
              </el-input>

            </el-form>
          </div>

        </el-col>
      </div>
      <div slot="footer">
        <el-button type="primary"
                   @click="tijiaopingjia()"
                   :disabled="isTiJiaoPingJia">提交</el-button>

      </div>
    </el-dialog>

  </div>
</template>

<script>
import PinyinMatch from "pinyin-match";
export default {
  name: "kehuyiwanchenggongdan",
  data () {
    return {
      gongdanCode: "",
      isChaXun: false,
      isTiJiaoPingJia: false,
      scrollbarHeight: (document.body.clientHeight - 200) + 'px',
      EchartsHeight: (document.body.clientHeight - 200) + 'px',
      WenTileixingList: [],
      kehumingcheng: "",
      kaishishijian: "",
      jieshushijian: "",
      staffcopy: [],
      staff: [], //产品线
      staffz: [], //产品线
      xingji: 5,
      miaoshu: "",
      colors: ['#FF8C00', '#FF8C00', '#FF8C00', '#FF8C00', '#FF8C00'],
      formDialog: false,
      mendianming: "",
      chanpinxian: "",
      shijianxuanze: "",
      restaurants: [], //门店数组
      loading: false,
      /**模板类型 */
      templateOptions: [{
        value: "F001",
        label: "巡店",
      },
      {
        value: "F002",
        label: "考核",
      },
      ],
      templateType: "F001",

      currPage: 1,
      pageSize: 50,
      allPage: 0,
      /**搜索表单 */
      searchForm: {
        type: "",
        status: "",
        start: "",
        end: "",
        name: "",
      },
      radio1: "全部",
      radio: 0,
      options: [],
      optionsa: [{
        value: "选项1",
        label: "黄金糕",
      },
      {
        value: "选项2",
        label: "双皮奶",
      },
      {
        value: "选项3",
        label: "蚵仔煎",
      },
      {
        value: "选项4",
        label: "龙须面",
      },
      {
        value: "选项5",
        label: "北京烤鸭",
      },
      ],
      value: "",
      shijian: "",
      list: [{
        title: "会员数量",
        num: "0",
        text: "今日订单数",
        textNum: "0",
        list: [{
          text: "商品管理",
          icon: "el-icon-goods",
          iconColor: "#73c4ff",
          name: "商品列表",
          parentName: "商品管理",
        },

        {
          text: "会员管理",
          icon: "el-icon-user",
          iconColor: "#91E6E1",
          name: "客户列表",
          parentName: "客户管理",
        },
        ],
      },],
      tableData: [],


    };
  },

  mounted () {
    const that = this;
    window.onresize = () => {
      // console.log('aaa',document.body.clientHeight)
      // return (() => {
      window.screenHeight = document.body.clientHeight
      // console.log('bbb',document.body.clientHeight)
      that.EchartsHeight = (window.screenHeight - 200) + 'px'
      that.EchartsHeightxjgd = (window.screenHeight - 200) + 'px'
      that.scrollbarHeight = (window.screenHeight - 200) + 'px'

      // })
    }
    this.getPerson()
    this.getWenTileixing()
    this.addDate();
    this.currPage = 1;
    this.ChaXun(this.currPage);

  },
  // activated() {
  // 	const that = this;
  // 	window.onresize = () => {
  // 		// console.log('aaa',document.body.clientHeight)
  // 		// return (() => {
  // 			window.screenHeight = document.body.clientHeight
  // 			// console.log('bbb',document.body.clientHeight)
  // 			that.EchartsHeight = (window.screenHeight - 200) + 'px'
  // 			that.EchartsHeightxjgd = (window.screenHeight - 200) + 'px'
  // 			that.scrollbarHeight = (window.screenHeight - 200) + 'px'

  // 		// })
  // 	}
  // 	this.getPerson()
  // 	this.getWenTileixing()
  // 	this.addDate();
  // 	this.currPage = 1;
  // 	this.ChaXun(this.currPage);
  // },
  // beforeRouteEnter(to, form, next) {
  // 	next(vm => {

  // 		vm.ChaXun(1)

  // 	})

  // },
  methods: {
    formatGap (index, row) {


      let staytimeGap = new Date().getTime() - new Date(row.HANDLE_TIME).getTime();
      let stayData = Math.floor(staytimeGap / (24 * 3600 * 1000));
      console.log("row", stayData, row, index)
      // if(stayData>30){


      // 			this.$set(this.tableData[index], 'pingjiazhangtai', '评价已超时')
      // 			console.log(this.tableData[index])


      // }
    },
    dianjichanpinxian () {
      this.staff = this.staffz;
      this.currPage = 1;
      this.ChaXun(this.currPage)
    },

    bindSelectChange (val) {

      if (val) {
        this.staff = this.staffcopy.filter((item) => {
          return PinyinMatch.match(item.Name, val) //(需要过滤的名称，输入的关键词)
        })
      } else {
        this.staff = this.staffcopy
      }

    },
    //双击查看工单
    shuangjiChaKan (row) {

      this.$router.push({
        path: "kehugongdanxiangqing",
        query: {
          zhuangtai: 'N',
          qianyiyemingcheng: '已完成工单',
          code: row.CODE,
          qianyiyemianglujing: "/home/kehuyiwanchenggongdan"
        }
      });
    },

    /**获取类型*/
    getWenTileixing () {
      this.loading = true;

      this.$request({
        method: "GET",
        url: "Dictionary/GetGdLx",
      })
        .then((res) => {
          this.loading = false;
          if (res.Code == '0' || res.Code == 0) {
            this.WenTileixingList = res.Data;
          }

        })
        .catch((err) => {
          if (err == "Error: Request failed with status code 401") {
            this.$router.push({
              path: "/login",
            });
          }
        });
    },

    //查询
    ChaXun (index) {
      this.currPage = index; //客户已完成
      this.loading = true;
      this.isChaXun = true;
      window.localStorage.setItem('khywcstartDate', this.kaishishijian)
      window.localStorage.setItem('khywcendDate', this.jieshushijian)
      this.$request({
        method: "GET",
        url: 'Info/KhGetYwcInfoList?chanpx=' + encodeURIComponent(this.chanpinxian) +
          "&startDate=" +
          encodeURIComponent(
            this.kaishishijian + " 00:00:00") + "&endDate=" + encodeURIComponent(this
              .jieshushijian + " 23:59:59") + "&code=" + encodeURIComponent(this.gongdanCode) +
          "&pageIndex=" + encodeURIComponent(index) + "&pageSize=" + encodeURIComponent(this
            .pageSize)
      })
        .then((res) => {
          this.isChaXun = false;
          this.loading = false;
          if (res.Code == '0' || res.Code == 0) {
            this.tableData = res.Data;
          }
          if (this.tableData.length > 0) {
            for (var i in this.tableData) {

              if (this.tableData[i].INFO_STATUS == 0) {
                this.$set(this.tableData[i], 'INFO_STATUS1', '已撤销')
              } else if (this.tableData[i].INFO_STATUS == 1) {
                this.$set(this.tableData[i], 'INFO_STATUS1', '已发起')
              } else if (this.tableData[i].INFO_STATUS == 2) {
                this.$set(this.tableData[i], 'INFO_STATUS1', '已接单')
              } else if (this.tableData[i].INFO_STATUS == 3) {
                this.$set(this.tableData[i], 'INFO_STATUS1', '已处理')
              } else if (this.tableData[i].INFO_STATUS == 4) {
                this.$set(this.tableData[i], 'INFO_STATUS1', '已驳回')
              } else if (this.tableData[i].INFO_STATUS == 5) {
                this.$set(this.tableData[i], 'INFO_STATUS1', '已完成')
              }
              if (this.tableData[i].SERVICE_STAR == 1 || this.tableData[i].SERVICE_STAR == 2 ||
                this.tableData[i].SERVICE_STAR == 3 || this.tableData[i].SERVICE_STAR == 4 ||
                this.tableData[i].SERVICE_STAR == 5) {
                this.$set(this.tableData[i], 'pingjiazhangtai', '已评价')
              } else {
                this.$set(this.tableData[i], 'pingjiazhangtai', '待评价')
              }
              this.formatGap(i, this.tableData[i]);
              for (var j in this.staff) {
                if (this.tableData[i].PRODUCT_LINE == this.staff[j].Code) {
                  this.$set(this.tableData[i], 'PRODUCT_LINE1', this.staff[j].Name)
                }
              }
              for (var z in this.WenTileixingList) {
                if (this.tableData[i].INFO_TYPE == this.WenTileixingList[z].Code) {
                  this.$set(this.tableData[i], 'INFO_TYPE1', this.WenTileixingList[z].Name)
                }
              }


            }
          }

          this.allPage = res.Total;
          if (this.$refs.header.offsetHeight == 0) {
            this.EchartsHeight = (document.body.clientHeight - 260) + 'px'

          } else {
            this.EchartsHeight = (document.body.clientHeight - this.$refs.header.offsetHeight -
              170) + 'px'

          }
        })
        .catch((err) => {
          this.isChaXun = false;
          if (err == "Error: Request failed with status code 401") {
            this.$router.push({
              path: "/login",
            });
          }
        });


    },
    //新建工单
    xinjianGongDan () {
      this.$router.push({
        path: "kehuxinjiangongdan"
      });
    },
    /**获取产品线 */
    getPerson () {
      this.loading = true;

      this.$request({
        method: "GET",
        url: "Dictionary/GetProducts",
      })
        .then((res) => {
          this.loading = false;
          if (res.Code == '0' || res.Code == 0) {

            this.staff = res.Data;
            this.staffz = res.Data;
            this.staffcopy = this.staff;


          }

        })
        .catch((err) => {
          if (err == "Error: Request failed with status code 401") {
            this.$router.push({
              path: "/login",
            });
          }
        });
    },
    //评价
    pingjia (row) {
      this.pingjiaxuanzhong = row;
      this.formDialog = true;
    },
    //提交评价
    tijiaopingjia () {
      let data = {

        CODE: this.tableData[this.pingjiaxuanzhong].CODE, //产品线
        SERVICE_EVALUATE: this.miaoshu, //服务评价
        SERVICE_STAR: this.xingji, //服务星级

      };
      // this.formDialog = true;
      this.isTiJiaoPingJia = true;
      this.scoped = true;

      this.$request({
        method: "post",
        url: "Info/UploadPingJia",
        data: data,
      })
        .then(() => {
          this.isTiJiaoPingJia = false;
          this.$message({
            message: "发起成功！",
            type: "success",
          });

          this.miaoshu = '';
          this.xingji = 5;
          this.formDialog = false;
          this.ChaXun(1);

        })
        .catch((err) => {
          this.isTiJiaoPingJia = false;
          if (err == "Error: Request failed with status code 401") {
            this.$router.push({
              path: "/login",
            });
          }
        });
    },

    getPath () {
      this.$router.push({
        path: "/login",
      });
    },

    addDate () {
      let nowDate = new Date();
      let date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        date: nowDate.getDate(),
      };

      if (date.month < 10) {
        date.month = '0' + date.month; //补齐
      }
      if (date.date < 10) {
        date.date = '0' + date.date; //补齐
      }
      // let shijianshuzu = [];
      let shijian = date.year + "-" + date.month + "-" + date.date;

      this.kaishishijian = shijian;
      this.jieshushijian = shijian;
      console.log(window.localStorage.getItem('khywcstartDate'))
      if (window.localStorage.getItem('khywcstartDate') != "null" && window.localStorage.getItem('khywcstartDate') != "") {
        this.kaishishijian = window.localStorage.getItem('khywcstartDate');
        this.jieshushijian = window.localStorage.getItem('khywcendDate');
      }
    },


    load () {
      this.count += 2;
    },


    /**分页size改变 */
    hanSiChange (val) {
      this.pageSize = val;
      this.currPage = 1;
      this.ChaXun(this.currPage);
    },
    /**当前页改变 */
    hanCurrChange (val) {
      this.currPage = val;
      this.ChaXun(this.currPage);
    },
    /**刷新表格数据 */
    handleRefresh () {
      this.currPage = 1;
      this.ChaXun(this.currPage);
    },


    /**查看分类下文档 */
    viewDoc (row) {
      this.$router.push({
        path: "kehugongdanxiangqing",
        query: {
          zhuangtai: 'Y',
          qianyiyemingcheng: '已完成工单',
          code: row.row.CODE,
          qianyiyemianglujing: "/home/kehuyiwanchenggongdan"
        }
      });

    },


  },
};
</script>

<style scoped>
.yiwanchenggongdan {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  /* padding: 20px; */
  padding-left: 0px;
  background-color: #f0f0f0;
}

.el-main {
  background-color: #f0f0f0;
  padding: 0px;
}

/* 头部选择模板名称 */
.header {
  height: 60px;
  background-color: #ffffff;
  padding-left: 20px;
  padding-top: 20px;
  /* width: calc(100%-10px); */
}

.headerTop {
  display: flex;
  justify-content: space-between;
}

.header-con {
  height: 40px;
  /* width: calc(100%-200px); */
  display: flex;
  align-items: center;
}

.header-con-form {
  display: flex;
  align-items: center;
}

.header-con-form-item {
  margin-bottom: 0;
}

.list {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  height: 100%;
}

.item {
  width: 100%;
  height: 100%;
}

.itema {
  margin-top: 10px;
  box-sizing: border-box;
  width: 100%;
  border-radius: 4px;
  height: 30px;
}

.itemb {
  margin-top: 10px;
  box-sizing: border-box;
  width: 100%;
  border-radius: 4px;
  margin-bottom: 0px;
  bottom: 0px;
}

.itemaBoxa {
  float: left;
  margin-top: 3px;
  margin-left: 0px;
  margin-left: 4px;
  width: 100px;
  height: 30px;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 25px;
  color: #000000;
  opacity: 1;
}

.itemaBoxb {
  float: left;
  margin-top: 0px;
  margin-left: 20px;
  width: 200px;
  height: 20%;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 25px;
  color: #000000;
  opacity: 1;
}

.itemaBoxc {
  float: left;
  margin-top: 0px;
  margin-left: 20px;
  width: 100px;
  height: 20%;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 25px;
  color: #000000;
  opacity: 1;
}

.itemBox {
  box-sizing: border-box;
  width: 100%;
  border: 1px solid #ebeef5;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  height: 80px;
}

.itemBoxa {
  float: left;
  top: 20px;
  left: 0px;
  margin-left: 4px;
  width: 20%;
  height: 20%;
}

.itemBoxb {
  float: left;
  top: 20px;
  left: 20%;
  margin-left: 4px;
  width: 20%;
  height: 20%;
}

.itemBoxc {
  float: left;
  top: 20px;
  left: 40%;
  margin-left: 4px;
  width: 20%;
  height: 20%;
}

.itemBoxd {
  float: left;
  top: 20px;
  left: 60%;
  margin-left: 4px;
  width: 20%;
  height: 20%;
}

.itemTop {
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 80px;
  padding: 0 25px;
  /* border-bottom: 1px solid #F2F4F9; */
}

.itemTopText {
  float: left;
  width: 80px;
  height: 22px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 25px;
  color: #000000;
  opacity: 1;
  margin-left: 10rpx;
}

.sousuoyou {
  float: right;
  margin-top: 20px;
  /* right: 30px; */
  margin-right: 20px;
  width: 92px;
  height: 36px;
  font-size: 16px;
  line-height: 18px;
  text-align: center;
  /* width: 100%;
  height: 100%; */
  overflow: hidden;
  /* background-color: #fff; */
}

.container {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}

/* 主体容器 */
.main {
  margin-top: 10px;
  height: 590px;
  overflow-y: auto;
  margin-right: 0px;
}

/* 主体容器 */
.maina {
  margin-top: 10px;
  height: 590px;
  overflow-y: auto;
  margin-right: 0px;
}

.yemakuandu {
  width: 99%;
  background-color: #fff;
  height: 40px;
  padding-top: 20px;
}

/**输入框宽度 */
.input {
  width: 200px;
}

/**dialog中样式 */
.dialog-con {
  height: 375px;
  overflow: auto;
}

.itemc {
  margin-top: 10px;
  box-sizing: border-box;
  width: 100%;
  margin-bottom: 10px;
  /* height: 98%; */
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  overflow-y: auto;
}

.itemcBoxa {
  width: 49.95%;
  height: 70px;
  max-height: 100px;
  float: none;

  background-color: #fff;
}

.itemd {
  box-sizing: border-box;
  width: 100%;
  height: 98%;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  overflow-y: auto;
}

.itemdtext {
  margin-left: 10px;
  margin-top: 20px;
  margin-bottom: 10px;
  width: 80%;
  height: 22px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 22px;
  color: #181818;
  opacity: 1;
  text-decoration: underline;
}

.itemdtexta {
  margin-left: 10px;
  margin-top: 20px;
  margin-bottom: 10px;
  width: 16%;
  height: 22px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 22px;
  color: #181818;
  opacity: 1;
  text-decoration: underline;
}

/**底部分页 */
.footer {
  height: 50px;
  margin-right: 0px;
}

.headerfueuxingji {
  margin-bottom: 0;
  margin-top: 0;
  margin-left: 25%;
  width: 50%;
  font-size: 16px;
  color: #666666;
}

.fuwuxingjiwz {
  height: 40px;
  line-height: 60px;
}

.fuwuxingjiwza {
  height: 140px;
  width: 100px;
  margin-top: -20px;
  font-size: 16px;
}

.liebiao {
  height: 40px;
}

/deep/.el-rate__icon {
  font-size: 38px;
}

/deep/ .iconyishoucang {
  color: #ffff00;
  font-size: 22px;
}

/deep/ .iconshoucang {
  color: #bbb;
  font-size: 22px;
}

.headermiaoshu {
  margin-bottom: 0;
  margin-top: 20px;
  margin-left: 25%;
  width: 70%;
  font-size: 16px;
  color: #666666;
}

/**dialog中样式 */
.dialog-con {
  height: 375px;
  overflow: auto;
}

.headerpingjia {
  margin-bottom: 0;
  text-align: center;
  width: 100%;
  font-size: 20px;
}

.taiyangImage {
  display: flex;
  justify-content: center;
  align-items: center;
}

.taiyangImagez {
  margin: 10px;
  width: 92px;
  height: 92px;
}

.containera {
  width: 100%;
  height: 100%;
  padding-left: 10px;
  margin-top: -10px;
  box-sizing: border-box;
  background-color: #ffffff;
}

.headerxjgd {
  margin-top: 10px;
  margin-bottom: 15px;
  padding-left: 20px;
}

.headeraxjgd {
  margin-bottom: 2px;
}

.fanhuiBtnxjgd {
  margin-top: 0px;
  margin-left: 0px;
  margin-bottom: 20px;
  display: inline-block;
}

.yonghuminglabexjgd {
  margin-top: 0px;
  margin-left: 90px;
  margin-bottom: 20px;
  display: inline-block;
}

/* 主体容器 */
.mainxjgd {
  height: 100%;
  /* overflow: hidden; */
  background-color: #fff;
  padding: 0px;
  margin-top: 20px;
  box-sizing: border-box;
}

/* 主体容器 */
.mainxjgda {
  height: 100%;
  /* overflow: hidden; */
  background-color: #fff;
  padding: 0px;
  margin-top: 20px;
  box-sizing: border-box;
}

.tijiaobtnxjgd {
  /* display: flex; */
  margin-top: 30px;
  margin-left: 50%;
  text-align: center;
  /* margin-left: 100px; */
  width: 100px;
}

.header-conxjgd {
  margin-left: 0px;
}

.header-conaxjgd {
  display: flex;
  align-items: center;
  height: 30px;
  margin-left: 30px;
}

.header-con-formxjgd {
  display: flex;
  align-items: center;
}

.header-con-form-itemxjgd {
  margin-bottom: 0;
}

/**输入框宽度 */
.form-item-inputxjgd {
  width: 470px;
}

/**输入框宽度 */
.form-item-inputxjgdms {
  width: 1149px;
}

/**输入框后面的备注 */
.form-item-tipxjgd {
  display: inline-block;
  margin-left: 10px;
  color: #606266;
  font-size: 14px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatarxjgd {
  width: 178px;
  height: 178px;
  display: block;
}

.shangchuantupianxjgd {
  margin-left: 90px;
  margin-bottom: 20px;
  width: 1149px;
}

.shangchuantupianxxjgd {
  margin-left: 10px;
  margin-top: 10px;

  display: inline-block;
}

.mediumxjgd {
  width: 470px;
  height: 30px;
  text-align: left;
  color: #999999;
  font-weight: 400;
}

.mediumaxjgd {
  width: 400px;
  height: 30px;
  text-align: left;
  color: #333333;
  font-weight: 400;
}

/**输入框宽度 */
.form-item-inputcpxxjgd {
  width: 400px;
}

.el-card {
  box-shadow: 0 1px 1px #f5f5f5 !important;
}

.wenjianmingchengzs {
  position: absolute;
  z-index: 0;
  width: 100%;
  margin-top: -90px;
  color: #ffffff;
  text-align: center;
  background-color: #3d546f;
}

/deep/.eloption .el-select-dropdown__wrap {
  max-height: 400px !important;
}

/deep/ .el-select__tags {
  flex-wrap: nowrap;
  overflow: hidden;
}
.el-table {
  overflow-y: auto !important;
  overflow-x: auto !important;
}
.weijiekongdan {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  /* padding: 20px; */
  padding-left: 0px;
  background-color: #f0f0f0;
}

.el-main {
  background-color: #f0f0f0;
  padding: 0px;
}

/* 头部选择模板名称 */
.header {
  height: auto;
  background-color: #ffffff;
  padding-left: 20px;
  padding-top: 20px;
  /* width: calc(100%-10px); */
}

.headerTop {
  display: flex;
  justify-content: space-between;
}

.header-con {
  height: auto;
  /* width: calc(100%-200px); */
  display: flex;
  align-items: center;
}

.header-con-form {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  word-wrap: break-word;
  overflow: hidden;
  margin: auto;
  /* 看自己需要设置，不影响div高度变化*/
}

.header-con-form-item {
  margin-bottom: 15px;
}

.list {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  height: 100%;
}

.item {
  width: 100%;
  height: 100%;
}

.itema {
  margin-top: 10px;
  box-sizing: border-box;
  width: 100%;
  border-radius: 4px;
  height: 30px;
}

.itemb {
  margin-top: 10px;
  box-sizing: border-box;
  width: 100%;
  border-radius: 4px;
  margin-bottom: 0px;
  bottom: 0px;
}

.itemaBoxa {
  float: left;
  margin-top: 3px;
  margin-left: 0px;
  margin-left: 4px;
  width: 100px;
  height: 30px;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 25px;
  color: #000000;
  opacity: 1;
}

.itemaBoxb {
  float: left;
  margin-top: 0px;
  margin-left: 20px;
  width: 200px;
  height: 20%;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 25px;
  color: #000000;
  opacity: 1;
}

.itemaBoxc {
  float: left;
  margin-top: 0px;
  margin-left: 20px;
  width: 100px;
  height: 20%;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 25px;
  color: #000000;
  opacity: 1;
}

.itemBox {
  box-sizing: border-box;
  width: 100%;
  border: 1px solid #ebeef5;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  height: 80px;
}

.itemBoxa {
  float: left;
  top: 20px;
  left: 0px;
  margin-left: 4px;
  width: 20%;
  height: 20%;
}

.itemBoxb {
  float: left;
  top: 20px;
  left: 20%;
  margin-left: 4px;
  width: 20%;
  height: 20%;
}

.itemBoxc {
  float: left;
  top: 20px;
  left: 40%;
  margin-left: 4px;
  width: 20%;
  height: 20%;
}

.itemBoxd {
  float: left;
  top: 20px;
  left: 60%;
  margin-left: 4px;
  width: 20%;
  height: 20%;
}

.anniuclass {
  margin-left: 20px;
  /* margin-top: 10px; */
  margin-bottom: 15px;
}

.itemTop {
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 80px;
  padding: 0 25px;
  /* border-bottom: 1px solid #F2F4F9; */
}

.itemTopText {
  float: left;
  width: 80px;
  height: 22px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 25px;
  color: #000000;
  opacity: 1;
  margin-left: 10rpx;
}

.sousuoyou {
  float: right;
  margin-top: 20px;
  /* right: 30px; */
  margin-right: 20px;
  width: 92px;
  height: 36px;
  font-size: 16px;
  line-height: 18px;
  text-align: center;
  /* width: 100%;
	height: 100%; */
  overflow: hidden;
  /* background-color: #fff; */
}

.container {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}

/* 主体容器 */
.main {
  margin-top: 10px;
  height: 590px;
  overflow-y: auto;
  margin-right: 0px;
}

/* 主体容器 */
.maina {
  margin-top: 10px;
  height: 590px;
  overflow-y: auto;
  margin-right: 0px;
}

.yemakuandu {
  width: 99%;
  background-color: #fff;
  height: 40px;
  padding-top: 20px;
}

/**输入框宽度 */
.input {
  width: 200px;
}

/**dialog中样式 */
.dialog-con {
  height: 375px;
  overflow: auto;
}

.itemc {
  margin-top: 10px;
  box-sizing: border-box;
  width: 100%;
  margin-bottom: 10px;
  /* height: 98%; */
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  overflow-y: auto;
}

.itemcBoxa {
  width: 49.95%;
  height: 70px;
  max-height: 100px;
  float: none;

  background-color: #fff;
}

.itemd {
  box-sizing: border-box;
  width: 100%;
  height: 98%;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  overflow-y: auto;
}

.itemdtext {
  margin-left: 10px;
  margin-top: 20px;
  margin-bottom: 10px;
  width: 80%;
  height: 22px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 22px;
  color: #181818;
  opacity: 1;
  text-decoration: underline;
}

.itemdtexta {
  margin-left: 10px;
  margin-top: 20px;
  margin-bottom: 10px;
  width: 16%;
  height: 22px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 22px;
  color: #181818;
  opacity: 1;
  text-decoration: underline;
}

/**底部分页 */
.footer {
  height: 50px;
  margin-right: 0px;
}

/**输入框宽度 */
.form-item-inputcpx {
  width: 200px;
}

.containera {
  width: 100%;
  height: 100%;
  padding-left: 10px;
  margin-top: -10px;
  box-sizing: border-box;
  background-color: #ffffff;
}

.headerxjgd {
  margin-top: 10px;
  margin-bottom: 15px;
  padding-left: 20px;
}

.headeraxjgd {
  margin-bottom: 2px;
}

.fanhuiBtnxjgd {
  margin-top: 0px;
  margin-left: 0px;
  margin-bottom: 20px;
  display: inline-block;
}

.yonghuminglabexjgd {
  margin-top: 0px;
  margin-left: 90px;
  margin-bottom: 20px;
  display: inline-block;
}

/* 主体容器 */
.mainxjgd {
  height: 100%;
  /* overflow: hidden; */
  background-color: #fff;
  padding: 0px;
  margin-top: 20px;
  box-sizing: border-box;
}

/* 主体容器 */
.mainxjgda {
  height: 100%;
  /* overflow: hidden; */
  background-color: #fff;
  padding: 0px;
  margin-top: 20px;
  box-sizing: border-box;
}

.tijiaobtnxjgd {
  /* display: flex; */
  margin-top: 30px;
  margin-left: 50%;
  text-align: center;
  /* margin-left: 100px; */
  width: 100px;
}

.tijiaobtnxjgdza {
  /* display: flex; */
  margin-top: 30px;
  text-align: center;
  /* margin-left: 100px; */
  width: 50%;
  display: inline-block;
}

.tckmingcheng {
  width: 100%;
  margin-left: 10px;
  text-align: center;
  font-size: 16px;
  color: #333333;
}

.tckmingchenga {
  width: 100%;
  margin-left: 10px;
  text-align: center;
  font-size: 16px;
  color: #333333;
  margin-top: 30px;
}

.tijiaobtnxjgda {
  /* display: flex; */
  margin-top: 0px;
  margin-left: 40%;
  margin-bottom: 20px;
  text-align: center;
  /* margin-left: 100px; */
  width: 100px;
  display: inline-block;
}

.tijiaobtnxjgdb {
  /* display: flex; */
  margin-top: 0px;
  margin-bottom: 20px;
  margin-right: 20%;
  text-align: center;
  /* margin-left: 100px; */
  width: 100px;
  display: inline-block;
}

.header-conxjgd {
  margin-left: 0px;
}

.header-conaxjgd {
  display: flex;
  align-items: center;
  height: 30px;
  margin-left: 30px;
}

.header-con-formxjgd {
  display: flex;
  align-items: center;
}

.sousuomingcheng {
  text-align: center;
  display: inline-block;
  margin-right: 10px;
  margin-left: 20px;
  font-size: 15px;
  font-weight: 400;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatarxjgd {
  width: 178px;
  height: 178px;
  display: block;
}

.el-card {
  box-shadow: 0 1px 1px #f5f5f5 !important;
}

/deep/.eloption .el-select-dropdown__wrap {
  max-height: 400px !important;
}

/deep/ .el-select__tags {
  flex-wrap: nowrap;
  overflow: hidden;
}

.el-table {
  overflow-y: auto !important;
  overflow-x: auto !important;
}
</style>
